import {
  asyncSuccess,
  asyncFailure,
  getRESTHeader,
  getQueryParams,
  objectToQueryParams
} from "utils"

export const readCountries = (options) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader() ,
    ...options,
  }

  return fetch(`${BASE_URL}/master/country`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}

export const readCities = (payload, options) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(
    `${BASE_URL}/master/city${getQueryParams(payload)}`,
    requestOptions,
  ).then(asyncSuccess, asyncFailure)
}

export const readStates = (payload, options) => {
    const requestOptions = {
      method: "GET",
      headers: getRESTHeader(),
      ...options,
    }
  
    return fetch(
      `${BASE_URL}/master/state${getQueryParams(payload)}`,
      requestOptions,
    ).then(asyncSuccess, asyncFailure)
  }

export const readObjectStatuses = (options) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(`${BASE_URL}/master/object-status`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}

export const readAllCurrencies = (options) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(`${BASE_URL}/master/currency`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}

export const readSupplierServices = (options) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(`${BASE_URL}/master/service`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}

export const readPaymentModes = ({query,...options}) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(`${BASE_URL}/master/payment-mode${getQueryParams(query)}`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}

export const readSuppliers = ({ query, ...options }) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(
    `${BASE_URL}/supplier${objectToQueryParams(query)}`,
    requestOptions,
  ).then(asyncSuccess, asyncFailure)
}

export const readVisaCountries = (options) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(`${BASE_URL}/master/visa-country`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}

export const readVisaStatus = (options) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(`${BASE_URL}/master/visa-status`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}